import { FrontBackMatterSidebarItem } from '.';

export const frontMatterApaItems: FrontBackMatterSidebarItem[] = [
  { type: 'titlePage', label: 'Title', routePath: 'title', canBeHidden: true, extraFieldName: 'title' },
  { type: 'copyrightPage', label: 'Copyright', routePath: 'copyright', canBeHidden: true, extraFieldName: 'copyright' },
  {
    type: 'approvedBy',
    label: 'Approved By',
    routePath: 'approved-by',
    canBeHidden: true,
    extraFieldName: 'approvedBy',
  },
  { type: 'dedication', label: 'Dedication', routePath: 'dedication', canBeHidden: true, extraFieldName: 'dedication' },
  {
    type: 'acknowledgements',
    label: 'Acknowledgements',
    routePath: 'acknowledgements',
    canBeHidden: true,
    extraFieldName: 'acknowledgements',
  },
  {
    type: 'tableOfContents',
    label: 'Table of Contents',
    routePath: 'table-of-contents',
    canBeHidden: true,
    extraFieldName: 'tableOfContents',
  },
  {
    type: 'listOfTables',
    label: 'List of Tables',
    routePath: 'list-of-tables',
    canBeHidden: true,
    extraFieldName: 'listOfTables',
  },
  {
    type: 'listOfFigures',
    label: 'List of Figures',
    routePath: 'list-of-figures',
    canBeHidden: true,
    extraFieldName: 'listOfFigures',
  },
  {
    type: 'abstract',
    label: 'Abstract',
    routePath: 'abstract',
    canBeHidden: true,
    extraFieldName: 'abstract',
  },
];

export const backMatterApaItems: FrontBackMatterSidebarItem[] = [
  { type: 'references', label: 'References', routePath: 'references', canBeHidden: false },
];
